import React, { useState, useEffect } from "react";

const PageWrapper = ({ config, children, onDateFilter }) => {
  // Compute today's and tomorrow's date in YYYY-MM-DD format
  const getLocalDate = (d) => {
    const offset = d.getTimezoneOffset();
    const local  = new Date(d.getTime() - offset * 60 * 1000);
    return local.toISOString().split("T")[0];
  };

  const today    = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const [startDate, setStartDate] = useState(getLocalDate(today));
  const [endDate,   setEndDate]   = useState(getLocalDate(today)); // ✅ today not tomorrow

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onDateFilter) onDateFilter(getLocalDate(today), getLocalDate(today));
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onDateFilter && startDate && endDate) {
      onDateFilter(startDate, endDate);
    }
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Breadcrumb + Date Filter */}
        <div className="row m-1">
          <div className="col-12 justify-content-between align-items-center">
            <div className="card">
              <div className="card-header">
                <h5>{config?.title || "Reports"}</h5>
              </div>
              <div className="card-body">
                <form className="app-form" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-4">
                      <div className="mb-3">
                        <label className="form-label">From Date</label>
                        <input
                          className="form-control"
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="mb-3">
                        <label className="form-label">To Date</label>
                        <input
                          className="form-control"
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="text-end mt-4">
                        <button className="btn btn-primary" type="submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="row advance-table-section">
          <div className="col-12">{children}</div>
        </div>
      </div>
    </main>
  );
};

export default PageWrapper;
